import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const WARNING_SECONDS = 2 * 60; // 2 minutes de compte à rebours

export default function SessionTimeoutModal() {
  const { sessionWarning, extendSession, logout } = useAuth();
  const [seconds, setSeconds] = useState(WARNING_SECONDS);

  useEffect(() => {
    if (!sessionWarning) {
      setSeconds(WARNING_SECONDS);
      return;
    }
    setSeconds(WARNING_SECONDS);
    const interval = setInterval(() => {
      setSeconds(s => {
        if (s <= 1) {
          clearInterval(interval);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [sessionWarning]);

  if (!sessionWarning) return null;

  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-timeout-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center space-y-4">
        {/* Icône */}
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
          <svg className="h-7 w-7 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>

        <h2 id="session-timeout-title" className="text-lg font-semibold text-gray-900">
          Session sur le point d'expirer
        </h2>

        <p className="text-sm text-gray-600">
          Vous n'avez pas eu d'activité depuis un moment. Pour votre sécurité, vous serez déconnecté automatiquement dans :
        </p>

        <div className="text-4xl font-bold text-amber-600 tabular-nums">
          {mm}:{ss}
        </div>

        <div className="flex gap-3 pt-2">
          <button
            onClick={logout}
            className="flex-1 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Se déconnecter
          </button>
          <button
            onClick={extendSession}
            className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
          >
            Rester connecté
          </button>
        </div>
      </div>
    </div>
  );
}
